/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import { Modal } from "react-bootstrap";
import { qreq } from "../shared/qrequest";
import BaseCom from "./BaseCom";
import Card from "./Card";
import Icon from "./Icon";
import './PatientLifecycle.css';
import FormInput from "./FormInput";
import Globals from "../shared/Globals";
import FormLabel from "./FormLabel";
import Wound from "./Wound";

export const PatientLifecycleGlobal = {
    showSelect() { }
}

class DetailPhaseModal extends BaseCom {
    constructor(props) {
        super(props);
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.load = this.load.bind(this);
        this.loadExam = this.loadExam.bind(this);
        PatientLifecycleGlobal.showDetail = this.show;
    }

    componentDidMount() {
        this.setState({ show: this.props.show, order: { ...this.props.order } });
    }

    componentDidUpdate(prevProps) {
        if (this.props.show !== prevProps.show) {
            this.setState({ show: this.props.show });
            this.load(this.props.phase);
        }
        if (this.props.order !== prevProps.order) {
            this.setState({ order: { ...this.props.order } });
            this.load(this.props.phase);
        }
        if (this.props.phase !== prevProps.phase) {
            this.load(this.props.phase);
        }
    }

    load(phase) {
        if(!phase?.id)
            return;
        qreq.get('/api/phase/order/' + this.props.order.id + '/get/' + phase.id, j => {
            if (j.item) {
                this.setState({ orderPhase: j.item });
                this.loadExam(phase);
                this.loadWounds(phase);
            }
            else if (j.errorCode === 4)
                this.setState({ orderPhase: {} });
            else
                this.alert(j.errorMessage);
        }, this.unkownErrorCallback);
    }

    loadExam(phase) {
        if(!phase?.id)
            return;
        qreq.get('/api/examination/order/' + this.props.order.id + '/phase/' + phase.id, j => {
            if (j.item) {
                try {
                    var exam = JSON.parse(j.item.jsonData);
                    this.setState({ exam: exam, examObj: j.item });
                }
                catch {
                    this.setState({ exam: null, examObj: null });
                }
            }
            else if (j.errorCode === 4)
                this.setState({ exam: null, examObj: null });
            else
                this.alert(j.errorMessage);
        }, this.unkownErrorCallback);
    }

    loadWounds(phase) {
        if(!phase?.id)
            return;
        qreq.get('/api/wound/order/' + this.props.order.id + '/phase/' + phase.id, j => {
            if (j.list) {
                this.setState({ wounds: j.list });
            }
            else if (j.errorCode === 4)
                this.setState({ wounds: null });
            else
                this.alert(j.errorMessage);
        }, this.unkownErrorCallback);
    }

    show() {
        this.setState({ show: true });
    }

    hide(success) {
        this.props.onHide?.();
        if (success)
            this.props.onSuccess?.();
        this.setState({ show: false });
    }

    render() {
        return <Modal show={this.state.show} onHide={this.hide} size="xl">
            <Modal.Header closeButton className="align-items-baseline">
                <Modal.Title>{this.props.phase?.name}</Modal.Title>
                <small className="d-block flex-fill ms-3 text-muted">{Globals.toMDYHMLocalDateString(this.state.orderPhase?.touchDate)}</small>
            </Modal.Header>
            <form onSubmit={this.submit}>
                <Modal.Body>
                    {this.state.orderPhase && <Card>
                        <FormLabel model={this.state.orderPhase.notes} label="Notes" />
                        {this.props.phase?.isFinal && this.props.order?.dischargeStatusName && <FormLabel model={this.props.order?.dischargeStatusName} label="Discharge Status" />}
                    </Card>}
                    {this.state.examObj && this.state.exam && <>
                    <Card>
                        {this.state.examObj && <small className="d-block text-secondary mb-3">From Examination Date: {Globals.toMDYHMLocalDateString(this.state.examObj.createdDate)}</small>}
                        {this.state.exam && <>
                            <div className="row">
                                <div className="col">
                                    <FormLabel model={this.state.exam.bloodPressure} label="Blood Pressure" />
                                </div>
                                <div className="col">
                                    <FormLabel model={this.state.exam.temperature} label="Temperature" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <FormLabel model={this.state.exam.heartRate} label="Heart Rate" />
                                </div>
                                <div className="col">
                                    <FormLabel model={this.state.exam.pulseOx} label="Pulse Ox" />
                                </div>
                            </div>
                        </>}
                    </Card>
                    </>}
                    {this.state.wounds && this.state.wounds.length !== 0 && <Card>
                        <h5>Wounds</h5>
                        <div className="row">
                            {this.state.wounds?.map(i => <div className="col-6 col-md-4" key={i.id}>
                                <Wound visit={this.state.visit} item={i} allowEdit={false} edit={false} />
                            </div>)}
                        </div>    
                    </Card>}
                </Modal.Body>
            </form>
        </Modal>;
    }
}

class SelectPhaseModal extends BaseCom {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        PatientLifecycleGlobal.showSelect = this.show;
    }

    async componentDidMount() {
        this.setState({ show: this.props.show, order: { ...this.props.order } });
        await this.fillListAsync('/api/order/discharge-status/list', 'dischargeStatusList');
    }

    componentDidUpdate(prevProps) {
        if (this.props.show !== prevProps.show)
            this.setState({ show: this.props.show });
        if (this.props.order !== prevProps.order)
            this.setState({ order: { ...this.props.order } });
    }

    show() {
        this.setState({ show: true });
    }

    hide(success) {
        this.props.onHide?.();
        if (success)
            this.props.onSuccess?.();
        this.setState({ show: false });
    }

    getPhase = (id) => {
        return this.props.phases.find(i => i.id === Number(id));
    }

    change = () => {
        this.setState({ order: { ...this.state.order } });
    }

    submit(e) {
        if (e) e.preventDefault();
        let order = { ...this.state.order };
        let phase = this.getPhase(order.phaseID);
        if(!phase.isFinal)
            order.dischargeStatusID = 0;
        qreq.post('/api/phase/update/order', order, j => {
            if (j.errorCode === 0) {
                this.success('Phase updated successfully');
                this.hide(true);
                this.props.onSuccess?.(order);
            }
            else
                this.alert(j.errorMessage);
        }, this.unkownErrorCallback);
    }

    render() {
        return <Modal show={this.state.show} onHide={this.hide}>
            <Modal.Header closeButton>
                <Modal.Title>Select Phase</Modal.Title>
            </Modal.Header>
            <form onSubmit={this.submit}>
                <Modal.Body>
                    {this.state.order && <>
                        <FormInput model={this.state.order} name="phaseID" label="Phase" type="select" options={this.props.phases} onChange={this.change} required />
                        {this.getPhase(this.state.order.phaseID)?.isFinal && <>
                            <FormInput model={this.state.order} name="dischargeStatusID" label="Discharge Status" type="select" options={this.state.dischargeStatusList ?? []} required onChange={this.change} />
                        </>}
                        <FormInput model={this.state.order} name="phaseNotes" label="Notes" type="textarea" rows={5} onChange={this.change} />
                    </>}
                </Modal.Body>
                <Modal.Footer>
                    <button type="submit" className="btn btn-primary"><Icon icon="faSave" /> Save</button>
                </Modal.Footer>
            </form>
        </Modal>;
    }
}

export default class PatientLifecycle extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            order: null,
            phases: [],
        };
        this.load = this.load.bind(this);
        this.phaseClick = this.phaseClick.bind(this);
    }

    componentDidMount() {
        qreq.get('/api/phase/list', j => {
            if (j.list)
                this.setState({ phases: j.list })
        });
        this.load();
    }

    componentDidUpdate(prevProps) {
        if (this.props.orderID !== prevProps.orderID || this.props.order !== prevProps.order)
            this.load();
    }

    load() {
        if (this.props.order) {
            this.setState({ order: this.props.order });
        }
        else if (this.props.orderID) {
            qreq.get('/api/order/get/' + this.props.orderID, j => {
                if (j.item)
                    this.setState({ order: j.item });
            });
        }
    }

    phaseClick(phase) {
        if (this.state.order?.phase.orderIndex < phase.orderIndex)
            return;
        this.setState({ phase: phase });
        PatientLifecycleGlobal.showDetail();
    }

    render() {
        if (!this.state.order)
            return null;
        return <>
            <SelectPhaseModal show={this.state.showSelectPhase} onHide={() => this.setState({ showSelectPhase: false })} order={this.state.order} phases={this.state.phases} onSuccess={this.props.onChange} />
            <DetailPhaseModal show={this.state.showDetailPhase} onHide={() => this.setState({ showDetailPhase: false })} order={this.state.order} phase={this.state.phase} />
            <Card title="Patient Lifecycle">
                <div className="d-flex justify-content-center">
                    <div>
                        {this.state.phases?.map(i => <div className="phase-wrapper" key={i.id}>
                            <div role={this.state.order?.phase.orderIndex >= i.orderIndex && 'button'} onClick={() => this.phaseClick(i)} className={'phase ' + (this.state.order?.phase.orderIndex >= i.orderIndex ? 'active' : 'inactive')} style={{ backgroundColor: this.state.order?.phase.orderIndex >= i.orderIndex ? i.color : '#ccc' }}>
                                <div className="phase-title">{i.name}</div>
                                {this.state.order?.phase.orderIndex >= i.orderIndex ? <div className="phase-date">{Globals.toMDYHMLocalDateString(this.state.order?.phaseList?.find(a => a.phaseID === i.id)?.touchDate)}</div> : null}
                            </div>
                            {!i.isFinal ? <Icon icon="faArrowDown" /> : null}
                        </div>)}
                    </div>
                </div>
            </Card>
        </>;
    }
}